/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-31 17:15:00
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-03 15:29:29
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/Components/RootWrapper/index.tsx
 */
import React from 'react';
import css from './css.module.less';

const WrapperRoot = (Comp) => {
  const Com = (props) => {
    return (
      <div className={css.rootContainer}>
        <Comp {...props} />
      </div>
    );
  };
  return Com;
};
export default WrapperRoot;
